export default __webpack_public_path__ + "static/media/bank-shield-icon.0a2c6907.png";